module.exports = __webpack_public_path__ + "img/swiper-right-btn2.8842f757.svg";